<template>
<div class="fc-page mg-page mg-shop_employee_list"><nav aria-label="面包屑"><v-breadcrumbs :items="breadcrumbs" divider="/" class="mg-breadcrumb"/></nav><header class="fc-heading"><div class="fc-child-heading"><h1>校区员工</h1><p>查看员工校区归属，管理校区任职状态</p></div><div class="mg-heading-actions"></div></header><section class="fc-filters" aria-label="校区员工筛选"><div class="fc-filter-heading"><h3>筛选条件</h3><span>按条件查找需要的记录</span></div><form @submit.prevent="getTableDataList"><div class="fc-filter-grid"><div class="fc-filter-cell"><v-select :items="selectShopList" v-model="query.shopId" item-text="shopName" item-value="id" label="校区" dense outlined color="#d9363e" aria-label="校区"></v-select></div>
<div class="fc-filter-cell"><v-text-field clearable dense label="员工号" outlined v-model="query.employeeNo" color="#d9363e" aria-label="员工号">
						</v-text-field></div></div><div class="fc-filter-bottom"><span>设置条件后点击查询</span><v-btn type="submit" color="#d9363e" dark depressed class="mg-query"><v-icon left size="17">mdi-magnify</v-icon>查询</v-btn></div></form></section><section class="fc-records" aria-label="校区员工列表"><div class="fc-list-heading"><h3>校区员工列表</h3><span class="fc-count">共 <strong>{{data.total}}</strong> 条</span></div><v-data-table :headers="data.headers" :items="data.list" :loading="query.loading" class="fc-table mg-table"
			disable-pagination hide-default-footer item-key="id" loading-text="正在加载,请稍候......" :mobile-breakpoint="0" no-data-text="暂无符合条件的记录">

			<template v-slot:item.shopEmployeeStatus="{item}">
				<v-chip small :color="statusColor(item.shopEmployeeStatus)">{{ statusName(item.shopEmployeeStatus) }}
				</v-chip>
			</template>

			<template v-slot:item.avatar="{item}">
				<v-avatar rounded class="my-1">
					<v-img v-if="item.avatar" :src="imgPrev + item.avatar" width="50" height="50"></v-img>
				</v-avatar>
			</template>

			<!-- <template v-slot:item.action="{item}">
				<v-btn @click="frozenShopEmployee(item)" :disabled="item.shopEmployeeStatus !== '1'" color="error" class="ml-3" x-small depressed>
					作废
				</v-btn>
				<v-btn @click="freeShopEmployee(item)" :disabled="item.shopEmployeeStatus === '1'" color="#d9363e" class="ml-3" x-small depressed>
					启用
				</v-btn>
			</template> -->

		</v-data-table><div class="fc-pagination"><div class="fc-page-size"><v-select :items="[10, 20, 50, 100]" @change="handleSizeChange" dense hide-details label="每页数量"
						outlined v-model="query.size" color="#d9363e" aria-label="每页数量" /><span>条 / 页</span><span class="fc-total">共 {{data.total}} 条</span></div><div v-if="Math.ceil(data.total/query.size)>0" class="mg-pagination"><v-pagination :length="Math.ceil(data.total/query.size)" @input="handleCurrentChange"
						:total-visible="5" v-model="query.page" color="#d9363e" /></div></div></section></div>
</template>

<script>

	import global from '../../../config/global'

	export default {
		name: "shop-employee-list",
		data() {
			return {
	
				breadcrumbs: [{
						text: '首页',
						disabled: false,
						href: "/"
					},
					{
						text: '系统管理',
						disabled: true
					},
					{
						text: '校区员工管理',
						disabled: true
					},
				],
				global:global,
				imgPrev: global.config.imgPre,
				data: {
					total: 0,
					headers: [
						{
							text: '校区',
							value: 'shopName',
							sortable: false
						},
						{
							text: '员工号',
							value: 'employeeNo',
							sortable: false
						},
						{
							text: '昵称',
							value: 'nickName',
							sortable: false
						},
						{
							text: '姓名',
							value: 'trueName',
							sortable: false
						},
						{
							text: '头像',
							value: 'avatar',
							sortable: false
						},
						{
							text: '手机号',
							value: 'mobile',
							sortable: false
						},
						{
							text: '在校状态',
							value: 'shopEmployeeStatus',
							sortable: false
						},
						{
							text: '创建时间',
							value: 'createAt',
							sortable: false
						},
						{
							text: '操作',
							align: 'center',
							value: 'action',
							sortable: false
						},
					],
					list: [],
				},
				selectShopList:[], //选择门店数据源
				query: {
					loading: false,
					page: 1,
					size: 20,
					shopId: "",
					employeeNo:""
				},
			}
		},
		created() {
			
			console.log(this.global.employee);
			if (this.global.employee.shopIdList&&this.global.employee.shopIdList[0]){
				this.query.shopId = this.global.employee.shopIdList[0];
				
			}
			
			this.getShopListForSelect();
			
			
			this.getTableDataList();

		},
		methods: {
			handleSizeChange(size) {
				this.query.size = size;
				this.query.page = 1;
				this.getTableDataList();
			},
			handleCurrentChange(page) {
				this.query.page = page;
				this.getTableDataList();
			},
			getShopListForSelect(){
				const that = this;
				let url = `/sys/merchant/shop/list`;
			
				this.axios.get(url).then(response => {
				
					if (response.data["code"] === 200) {
						that.selectShopList = response.data["data"] ? response.data["data"] : [];
						return
					}
					
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			
			getTableDataList() {
				const that = this;
				this.query.loading = true;

				let url = `/sys/shop/employee/list/page/${that.query.page - 1}/size/${that.query.size}?v=1`;
				
				if (this.query.shopId) {
					url += "&shopId=" + this.query.shopId;
				}
				if (this.query.employeeNo) {
					url += "&employeeNo=" + this.query.employeeNo;
				}

				this.axios.get(url).then(response => {
					
					console.log(response);
					
					if (response.data["code"] === 200) {
						that.data.list = response.data["data"]["list"] ? response.data["data"]["list"] : [];
						that.data.total = response.data["data"]["count"];

						that.query.loading = false;
						return
					}
					that.query.loading = false;
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			
			statusName(state) {

				let stName = "未知";
				if (state === "1") {
					stName = "正常";
				} else if (state === "0") {
					stName = "冻结";
				}
				return stName;
			},
			statusColor(state) {
				let color = "";
				if (state === "1") {
					color = "success";
				} else if (state === "0") {
					color = "error";
				}

				return color;
			},
			frozenShopEmployee(item) {
				//冻结
				const that = this;
				let url = `/sys/shop/employee/frozen/${item.id}`;
				this.axios.post(url).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("冻结成功");
							that.getTableDataList();
							return;
						}else{
							that.$noty.error("操作失败," + res.data["message"]);
							return;
						}
					} else {
						that.$noty.error('远程请求失败');
					}

				});
			},
			freeShopEmployee(item) {
				//解冻
				const that = this;
				let url = `/sys/shop/employee/free/${item.id}`;
				this.axios.post(url).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("解冻成功");
							that.getTableDataList();
							return;
						}
					} else {
						that.$noty.error('远程请求失败');
					}

				});
			},
			

		}
	}
</script>
<style>
</style>
<style lang="scss" scoped src="../../../assets/styles/management.scss"></style>
